import { faIdCard, faPenNib, faPhotoVideo } from '@fortawesome/pro-light-svg-icons'

import type { CampaignModel } from '@models/types'

import { generateUrls } from '@hooks/useCampaign'

type GenerateTabBarItemsType = {
  campaign: CampaignModel,
  isProviderUser: boolean,
  showCopywritingTab?: boolean,
  showMediaTab?: boolean,
}

const generateTabBarItems = (params: GenerateTabBarItemsType) => {
  const {
    campaign, isProviderUser, showCopywritingTab = true, showMediaTab = true,
  } = params

  const urls = generateUrls(campaign)
  const { editCampaignUrl, campaignMediaProviderUrl, campaignCopywritingProviderUrl } = urls

  const tabs = [
    {
      icon: faIdCard,
      href: editCampaignUrl,
      key: 'details',
      title: campaign?.title || 'Campaign Details',
    },
  ]

  if (showMediaTab){
    tabs.push({
      icon: faPhotoVideo,
      // @ts-expect-error TS2353
      hidden: !isProviderUser,
      href: campaignMediaProviderUrl,
      key: 'media',
      title: 'Media',
    })
  }

  if (showCopywritingTab){
    tabs.push({
      icon: faPenNib,
      // @ts-expect-error TS2353
      hidden: !isProviderUser,
      href: campaignCopywritingProviderUrl,
      key: 'copywriting',
      title: 'Copywriting',
    })
  }

  return tabs
}

export default generateTabBarItems
